"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VWOEvents = void 0;
var VWOEvents;
(function (VWOEvents) {
    VWOEvents["USER_CLICKED_ON_SEND_ORDER"] = "clickOnSendOrderOnCart";
    VWOEvents["USER_CLICKED_ON_CHOOSE_MORE"] = "clickOnChooseMoreOnCart";
    VWOEvents["CLICK_ON_VIEW_PRODUCT"] = "clickOnViewProduct";
    VWOEvents["CLICK_ON_CHANGE_PRODUCT_QUANTITY"] = "clickOnChangeProductQuantity";
    VWOEvents["CLICK_ON_REMOVE_PRODUCT_FROM_CART"] = "clickOnRemoveProductFromCart";
})(VWOEvents = exports.VWOEvents || (exports.VWOEvents = {}));
